import { Interval } from 'luxon';

export const checkIfNewCandle = ({
  nextCandleTimeStampRef,
  currentCandleTimeStamp,
}) => {
  if (currentCandleTimeStamp >= nextCandleTimeStampRef.current && currentCandleTimeStamp && nextCandleTimeStampRef.current) {
    return true;
  } else return false;
};

export const newCheckIfNewCandle = ({
  currentCandle,
  currentCandleTimeStamp,
  nextCandleTimeStampRef,
  timeUnit,
  candleDuration,
}) => {
  if (timeUnit === 'MINUTES') {
    if (currentCandleTimeStamp >= nextCandleTimeStampRef.current) {
      return true;
    } else return false;
  }
  if (timeUnit === 'DAYS') {
    const start = currentCandle.timeStamp;
    const end = currentCandleTimeStamp;
    const i = Interval.fromDateTimes(start, end);
    if (i.length('days') >= candleDuration) return true;
    else return false;
  }
  if (timeUnit === 'WEEKS') {
    const start = currentCandle.timeStamp;
    const end = currentCandleTimeStamp;
    const i = Interval.fromDateTimes(start, end);
    if (i.length('weeks') >= candleDuration) return true;
    else return false;
  }
  if (timeUnit === 'MONTHS') {
    const start = currentCandle.timeStamp;
    const end = currentCandleTimeStamp;
    const i = Interval.fromDateTimes(start, end);
    if (i.length('months') >= candleDuration) return true;
    else return false;
  }
  if (timeUnit === 'YEARS') {
    const start = currentCandle.timeStamp;
    const end = currentCandleTimeStamp;
    const i = Interval.fromDateTimes(start, end);
    if (i.length('years') >= candleDuration) return true;
    else return false;
  }
};
